import { Language } from "@fidget/common/models/language";

export class ViewTexts {
  constructor(private readonly language: Language) {}

  public getMessageFromLabel(): string {
    return this.language === Language.PL
      ? "Nowa wiadomość od: "
      : "New Message from ";
  }

  public getAdviserLabel(): string {
    return this.language === Language.PL ? "Doradca" : "Adviser";
  }
}
